<template>
  <v-container class="py-0 px-5">
    <v-row
      v-for="(item, i) in payment.items"
      :key="i"
      dense
    >
      <v-col
        cols="12"
        md="7"
      >
        <h3 class="py-3">
          {{ $t(item.name+'_payment') }} :
        </h3>
      </v-col>
      <v-col
        cols="12"
        md="5"
      >
        <validated-text-field
          v-model="item.amount"
          field-name="amount_huf"
          rules="required|numeric|min_value:0"
          type="number"
        />
      </v-col>
      <v-col
        cols="12"
        md="5"
      >
        <validated-text-field
          v-if="false"
          v-model="item.description"
          field-name="comment"
          rules=""
          type="text"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'StartPayment',
    props: {
      payment: Object,
    },
  }
</script>
